import React from "react";
import { StationUnavailableInAppTemplate } from "themes/application/common/components";

function StationUnavailableInApp(props) {
    return <StationUnavailableInAppTemplate {...props} />;
}

export default StationUnavailableInApp;
